<template>
  <div class="flex items-center flex-col">
    <h3 class="text-xl">Поздравляем с завершением теста🎉</h3>
    <p>
      Когда-нибудь здесь будут отображаться ваши результаты, но это будет не
      сегодня
    </p>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'end-quiz',
  setup() {},
})
</script>
